export default "__VITE_ASSET__CF8P8WeB__"